import { FaGithub, FaServer, FaLock, FaExternalLinkAlt } from "react-icons/fa";
import { STATUS_MAP_ROUTE } from "../../../_Catalogs.Views";
import { StatusBadge } from "../../../../../_CORE/APP/Templates/_UI/Status/_index";
import { Card, EmptyState } from "../../../../../_CORE/APP/Templates/_UI/Kit/_index";

export const PanelProjectInfo = ({ project }) => {

    const REPOSITORIES = [
        { label: "Frontend", url: project.repositoryFrontend },
        { label: "Backend", url: project.repositoryBackend },
        { label: "Otro", url: project.repositoryOther },
    ].filter((item) => !!item.url);

    const ROUTES = [...(project.routes ?? [])].sort((a, b) => a.position - b.position);

    return (
        <div className="LStudio__app_project_info">

            <Card title="Repositorios">
                {
                    REPOSITORIES.length === 0 ? (
                        <EmptyState icon={<FaGithub />} title="Sin repositorios cargados" size="sm" />
                    ) : (
                        <ul className="LStudio__app_project_info_list">
                            {
                                REPOSITORIES.map((repository) => (
                                    <li key={repository.label} className="LStudio__app_project_info_item">

                                        <span className="LStudio__app_project_info_label">{repository.label}</span>

                                        <a href={repository.url} target="_blank" rel="noreferrer"
                                            className="LStudio__app_project_info_link">
                                            {repository.url} <FaExternalLinkAlt />
                                        </a>

                                    </li>
                                ))
                            }
                        </ul>
                    )
                }
            </Card>

            <Card title="Rutas">
                {
                    ROUTES.length === 0 ? (
                        <EmptyState icon={<FaServer />} title="Sin rutas cargadas" size="sm" />
                    ) : (
                        <ul className="LStudio__app_project_info_list">
                            {
                                ROUTES.map((route) => (
                                    <li key={route.id} className="LStudio__app_project_info_item">

                                        <StatusBadge status={route.environment} map={STATUS_MAP_ROUTE} size="sm" />

                                        <a href={route.url} target="_blank" rel="noreferrer"
                                            className="LStudio__app_project_info_link">
                                            {route.label ? `${route.label} — ` : ""}{route.url} <FaExternalLinkAlt />
                                        </a>

                                    </li>
                                ))
                            }
                        </ul>
                    )
                }
            </Card>

            <Card title="Pin de acceso">
                {
                    project.hasAccessPin ? (
                        <div className="LStudio__app_project_info_pin">

                            <span className="LStudio__app_project_info_pin_state"><FaLock /> Pin activo</span>

                            <p className="LStudio__app_project_info_empty">
                                Se pide para mostrar contraseñas, tokens y cadenas de conexión. No se puede consultar
                                desde acá: si lo olvidaste, asignale uno nuevo editando el proyecto.
                            </p>

                        </div>
                    ) : (
                        <p className="LStudio__app_project_info_empty">
                            Este proyecto no tiene pin, así que las credenciales se revelan sin pedir nada.
                            Podés asignarlo editando el proyecto.
                        </p>
                    )
                }
            </Card>

        </div>
    );
};
